import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { UnauthLayout } from "../../layouts/UnauthLayout";

const LoginPage = lazy(() =>
  import("./pages/LoginPage").then((m) => ({ default: m.LoginPage }))
);
const LogoutPage = lazy(() =>
  import("./pages/LogoutPage").then((m) => ({ default: m.LogoutPage }))
);
const ChangePasswordPage = lazy(() =>
  import("./pages/ChangePasswordPage").then((m) => ({ default: m.ChangePasswordPage }))
);
const ForgotPasswordPage = lazy(() =>
  import("./pages/ForgotPasswordPage").then((m) => ({ default: m.ForgotPasswordPage }))
);
const ResetPasswordPage = lazy(() =>
  import("./pages/ResetPasswordPage").then((m) => ({ default: m.ResetPasswordPage }))
);

export const AuthRoutes: RouteObject = {
  path: "/auth",
  element: <UnauthLayout />,
  children: [
    {
      path: "login",
      element: <LoginPage />,
    },

    {
      path: "logout",
      element: <LogoutPage />,
    },
    {
      path: "change-password",
      element: <ChangePasswordPage />,
    },
    {
      path: "forgot-password",
      element: <ForgotPasswordPage />,
    },
    {
      path: "reset-password",
      element: <ResetPasswordPage />,
    },
  ],
};
